import styles from "./customer-loader.module.scss";

interface CustomerLoaderLoaderProps {
    title?: string;
    subtitle?: string;
}
export const CustomerLoader = ({ title, subtitle}: CustomerLoaderLoaderProps) =>{
  return(
    <div className={styles.paymentProcessorOverlay}>
			<div className={styles.paymentProcessor}>
				<div className={styles.contentArea}>
					<div className={styles.iconContainer}>
							<div className={styles.loadingSpinner}>
								<div className={styles.spinner} />
							</div>
						</div>
						{title &&<h2 className={styles.title}>{title}</h2>}
						{subtitle && <p className={styles.subtitle}>{subtitle}</p>}
				</div>
			</div>
		</div>
  )
}